{
  "queryName": "fairsharingGraph",
  "queryParam": null,
  "fields": ["data"]
}
